// main.js
import { initializeImageWidget } from './image-upload-widget.js';
import { initializeFileWidget  } from './file-upload-widget.js';

$(document).ready(() => {
  $('.file-widget').each(function() {
    const widget = $(this);
    widget.data('type') === 'image'
      ? initializeImageWidget(widget)
      : initializeFileWidget(widget);
  });
});
